// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ouNa","content":"styles_content__1JzV8","tableWrap":"styles_tableWrap__t7LuF"};